module.exports = __webpack_public_path__ + "img/logo-main.663a99f0.svg";